import { APP } from './index';
import { Action } from '../action';

export class AppInitAction implements Action {
	readonly type = APP.INIT;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AppDestroyAction implements Action {
	readonly type = APP.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
